/**
 * Meine Drucker
 *
 * Gast: localStorage = Puffer.
 * Eingeloggt: Server-Metafeld custom.devices = Wahrheit (App Proxy add/remove/reorder/merge).
 * localStorage ist nur Spiegel der Server-Antwort; Login = einmaliger Union-Merge.
 */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Platzhaltername
  // ---------------------------------------------------------------------------
  // Kommt ein Geraet ohne Namen an, zeigen wir einen Platzhalter - und der landet
  // per JSON.stringify mit in localStorage. Derselbe Wert dient deshalb als Marker
  // "noch kein echter Name" (siehe mergeServerDevicesIntoLocal).
  //
  // Der Vergleich darf sich nicht auf die aktuelle Sprache allein verlassen:
  // localStorage ist origin-scoped, und CH fuehrt als einziger Markt zwei Sprachen
  // auf EINER Domain (de + fr). Dort kann ein deutscher Platzhalter gespeichert
  // sein, waehrend die Seite franzoesisch ausgeliefert wird. Fuer diesen Fall
  // liefert das Theme in myPrintersDeviceFallbackAliases die Geschwister-Sprachen
  // mit; ueberall sonst ist die Liste leer und es zaehlt nur die Shop-Sprache.
  // Alle sichtbaren Texte kommen aus window.languages (layout/theme.liquid).
  // Fehlt die Bruecke - etwa beim Rendern ueber die Section-Rendering-API -,
  // faellt t() auf den mitgegebenen Standard zurueck, damit nie "undefined"
  // in der Oberflaeche landet.
  function lang(key, fallback) {
    var L = window.languages || {};
    return L[key] != null ? L[key] : fallback;
  }

  function deviceFallbackName() {
    return lang('myPrintersDeviceFallback', 'Drucker');
  }

  function isPlaceholderName(name) {
    if (!name) return true;
    if (name === deviceFallbackName()) return true;
    var L = window.languages || {};
    var aliases = L.myPrintersDeviceFallbackAliases;
    if (aliases && aliases.indexOf(name) !== -1) return true;
    // Altbestand: vor der Verschluesselung wurde der Platzhalter immer deutsch
    // gespeichert. Historischer Wert, kein UI-Text - daher hart.
    return name === 'Drucker';
  }

  const APPPROXY_URL = '/apps/mcb/my-printers';
  const STORAGE_KEY = 'mc_my_printers_v1';
  const PENDING_KEY = 'mc_my_printers_pending_v1';
  const MERGED_KEY = 'mc_my_printers_merged_v1';
  const GUEST_DIRTY_KEY = 'mc_my_printers_guest_dirty_v1';
  const LAST_CUSTOMER_KEY = 'mc_my_printers_last_customer_v1';
  const WAS_LOGGED_IN_KEY = 'mc_my_printers_was_logged_in_v1';

  var SVG_TRASH =
    '<svg focusable="false" class="icon icon--trash" viewBox="0 0 24 24" role="presentation" aria-hidden="true">' +
    '<path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';
  var SVG_ARROW_R =
    '<svg focusable="false" class="icon icon--arrow-right" viewBox="0 0 24 24" role="presentation" aria-hidden="true">' +
    '<path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';

  const widget = document.getElementById('mc-my-printers-widget');
  //
  // console.log(
  //   '[MyPrinters] data-mc-guest=',
  //   widget ? widget.getAttribute('data-mc-guest') : '(no widget)',
  //   'data-mc-customer-id=',
  //   widget ? widget.getAttribute('data-mc-customer-id') : '(no widget)'
  // );

  /** Klick kann auf Textknoten landen — Text hat kein .closest(). */
  function eventTargetElement(ev) {
    var t = ev && ev.target;
    if (!t) return null;
    if (t.nodeType === 1) return t;
    return t.parentElement || null;
  }

  function isGuest() {
    return !!(widget && widget.getAttribute('data-mc-guest') === 'true');
  }

  function getCustomerId() {
    if (!widget) return '';
    return (widget.getAttribute('data-mc-customer-id') || '').trim();
  }

  function getMergedCustomerId() {
    try {
      return sessionStorage.getItem(MERGED_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setMergedForCustomer(customerId) {
    try {
      if (customerId) {
        sessionStorage.setItem(MERGED_KEY, String(customerId));
        sessionStorage.setItem(LAST_CUSTOMER_KEY, String(customerId));
        localStorage.setItem(WAS_LOGGED_IN_KEY, '1');
      } else {
        sessionStorage.removeItem(MERGED_KEY);
      }
    } catch (e) {}
  }

  function clearMergedFlag() {
    try {
      sessionStorage.removeItem(MERGED_KEY);
    } catch (e) {}
  }

  function getLastCustomerId() {
    try {
      return sessionStorage.getItem(LAST_CUSTOMER_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function clearLastCustomerId() {
    try {
      sessionStorage.removeItem(LAST_CUSTOMER_KEY);
    } catch (e) {}
  }

  function wasLoggedIn() {
    try {
      return localStorage.getItem(WAS_LOGGED_IN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  /** Logout / leave logged-in session: wipe Meine Drucker GUI + storage. */
  function resetAfterLogout() {
    clearMergedFlag();
    clearLastCustomerId();
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(PENDING_KEY);
      localStorage.removeItem(GUEST_DIRTY_KEY);
      localStorage.removeItem(WAS_LOGGED_IN_KEY);
    } catch (e) {}
    if (widget) {
      renderWidgetFromStorage([]);
      syncBadgeFromStorage();
      syncCollectionButtonsFromStorage();
    }
    // console.log('[MyPrinters] cleared local state after logout');
  }

  function setGuestDirty() {
    try {
      localStorage.setItem(GUEST_DIRTY_KEY, '1');
    } catch (e) {}
  }

  function clearGuestDirty() {
    try {
      localStorage.removeItem(GUEST_DIRTY_KEY);
    } catch (e) {}
  }

  function isGuestDirty() {
    try {
      return localStorage.getItem(GUEST_DIRTY_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  // ---------------------------------------------------------------------------
  // localStorage
  // ---------------------------------------------------------------------------

  function loadGuestDevices() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveGuestDevices(devices) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(devices));
    } catch (e) {
      console.error('[MyPrinters] localStorage write failed', e);
    }
  }

  const PENDING_MAX = 40;

  function loadPendingOps() {
    try {
      var raw = localStorage.getItem(PENDING_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function savePendingOps(ops) {
    try {
      if (!ops || !ops.length) localStorage.removeItem(PENDING_KEY);
      else localStorage.setItem(PENDING_KEY, JSON.stringify(ops));
    } catch (e) {
      console.error('[MyPrinters] pending queue write failed', e);
    }
  }

  /**
   * Enqueue a failed write for retry. Coalesces reorder/merge (latest wins),
   * collapses add/remove for the same GID, and caps queue length.
   */
  function enqueuePending(op) {
    var ops = loadPendingOps();
    var next = Object.assign({ ts: Date.now() }, op);

    if (next.action === 'reorder' || next.action === 'merge') {
      ops = ops.filter(function (o) {
        return o.action !== next.action;
      });
      ops.push(next);
    } else if (
      (next.action === 'add' || next.action === 'remove') &&
      next.deviceGid
    ) {
      ops = ops.filter(function (o) {
        return !(
          o.deviceGid === next.deviceGid &&
          (o.action === 'add' || o.action === 'remove')
        );
      });
      ops.push(next);
    } else {
      ops.push(next);
    }

    if (ops.length > PENDING_MAX) {
      ops = ops.slice(ops.length - PENDING_MAX);
    }
    savePendingOps(ops);
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }

  function typeLabel(type) {
    var t = (type || '').toLowerCase();
    if (t === 'ink') return escapeHtml(lang('myPrintersTypeInk', 'Tinte'));
    if (t === 'toner') return escapeHtml(lang('myPrintersTypeToner', 'Toner'));
    return type ? escapeHtml(type) : '';
  }

  function syncBadgeFromStorage() {
    var n = loadGuestDevices().length;
    document.querySelectorAll('.mc-my-printers-toggle__icon').forEach(function (iconEl) {
      var countEl = iconEl.querySelector('.mc-my-printers-toggle__count');
      if (n === 0) {
        if (countEl) countEl.remove();
        return;
      }
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'mc-my-printers-toggle__count';
        iconEl.appendChild(countEl);
      }
      countEl.textContent = String(n);
    });
  }

  function isPhoneLayout() {
    if (typeof Responsive !== 'undefined' && Responsive.matchesBreakpoint) {
      return Responsive.matchesBreakpoint('phone');
    }
    return window.matchMedia('screen and (max-width: 640px)').matches;
  }

  /** Closes overlay, opens header search (expands search bar if condensed/hidden). */
  function focusMcSearch() {
    closeWidget();
    var phone = isPhoneLayout();
    window.setTimeout(function () {
      var wrapper = document.querySelector('.header__search-bar-wrapper');
      var input = wrapper && wrapper.querySelector('.search-bar__input');
      var header = document.querySelector('.header');
      var toggleBtn = document.querySelector('.header [data-action="toggle-search"]');
      var searchHidden =
        wrapper &&
        !wrapper.classList.contains('is-visible') &&
        !(header && header.classList.contains('header--search-expanded'));

      // Phone or condensed desktop search: expand via the theme toggle first.
      if ((phone || searchHidden) && header && toggleBtn && !header.classList.contains('header--search-expanded')) {
        toggleBtn.click();
        window.setTimeout(function () {
          if (input) {
            input.focus({ preventScroll: false });
            input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
          }
        }, 300);
        return;
      }

      if (input) {
        input.focus({ preventScroll: false });
        input.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
      }
    }, phone ? 0 : 150);
  }

  function syncCollectionButtonsFromStorage() {
    var saved = loadGuestDevices();
    var gids = new Set(saved.map(function (d) { return d.deviceGid; }));

    document.querySelectorAll('.mc-add-to-printers').forEach(function (wrap) {
      var gid = wrap.getAttribute('data-device-gid');
      if (!gid) return;
      var btn = wrap.querySelector('.js-mc-add-to-printers-btn');
      if (!btn) return;

      if (gids.has(gid)) {
        btn.classList.add('mc-add-to-printers__btn--saved');
        btn.setAttribute('data-action', 'open-my-printers-edit');
        btn.innerHTML =
          '<span class="mc-add-to-printers__icon" aria-hidden="true">&#x2713;</span>' +
          '<span class="mc-add-to-printers__text">' + escapeHtml(lang('myPrintersButtonSaved', 'Zu meinen Druckern hinzugef\u00fcgt')) + '</span>';
      } else {
        btn.classList.remove('mc-add-to-printers__btn--saved');
        btn.setAttribute('data-action', 'add-to-my-printers');
        var isTitle = wrap.getAttribute('data-mc-placement') === 'title';
        btn.innerHTML = isTitle
          ? '<span class="mc-add-to-printers__icon" aria-hidden="true">&gt;&gt;</span>' +
            '<span class="mc-add-to-printers__text">' + escapeHtml(lang('myPrintersButtonAdd', 'Zu meinen Druckern hinzuf\u00fcgen')) + '</span>'
          : '<span class="mc-add-to-printers__icon" aria-hidden="true">+</span>' +
            '<span class="mc-add-to-printers__text">' + escapeHtml(lang('myPrintersButtonAdd', 'Zu meinen Druckern hinzuf\u00fcgen')) + '</span>';
      }
    });
  }

  function guestDeviceRowList(d) {
    var img =
      d.imageUrl
        ? '<img src="' +
          escapeHtml(d.imageUrl) +
          '" alt="' +
          escapeHtml(d.name) +
          '" width="60" height="60" loading="lazy">'
        : '<div class="mc-my-printers__item-placeholder"><span aria-hidden="true">&#128424;</span></div>';
    var typeHtml = d.type
      ? '<span class="mc-my-printers__item-type mc-my-printers__item-type--' +
        escapeHtml(String(d.type).toLowerCase()) +
        '">' +
        typeLabel(d.type) +
        '</span>'
      : '';
    return (
      '<a href="/collections/' +
      escapeHtml(d.handle) +
      '" class="mc-my-printers__item" data-device-gid="' +
      escapeHtml(d.deviceGid) +
      '">' +
      '<div class="mc-my-printers__item-image">' +
      img +
      '</div>' +
      '<div class="mc-my-printers__item-info">' +
      '<span class="mc-my-printers__item-name">' +
      escapeHtml(d.name) +
      '</span>' +
      typeHtml +
      '</div>' +
      '<span class="mc-my-printers__item-arrow">' +
      SVG_ARROW_R +
      '</span>' +
      '</a>'
    );
  }

  function guestDeviceRowEdit(d) {
    return (
      '<div class="mc-my-printers__edit-item" data-device-gid="' +
      escapeHtml(d.deviceGid) +
      '" draggable="true">' +
      '<span class="mc-my-printers__drag-handle" aria-label="' + escapeHtml(lang('myPrintersDragHandle', 'Ziehen zum Sortieren')) + '">&#x2630;</span>' +
      '<div class="mc-my-printers__edit-item-info">' +
      '<span class="mc-my-printers__edit-item-name">' +
      escapeHtml(d.name) +
      '</span></div>' +
      '<button type="button" class="mc-my-printers__delete-btn" data-action="my-printers-remove" data-device-gid="' +
      escapeHtml(d.deviceGid) +
      '" aria-label="' +
      escapeHtml(lang('myPrintersRemoveDevice', '__NAME__ entfernen').replace('__NAME__', d.name)) +
      '">' +
      SVG_TRASH +
      '</button></div>'
    );
  }

  function renderWidgetFromStorage(devices) {
    if (!widget) return;

    var listMount = widget.querySelector('.js-my-printers-list-mount');
    var editMount = widget.querySelector('.js-my-printers-edit-mount');
    var emptyEl = widget.querySelector('.js-my-printers-empty');
    var listSection = widget.querySelector('.mc-my-printers__list[data-my-printers-view="list"]');
    var actions = widget.querySelector('.js-my-printers-actions');

    if (!devices.length) {
      switchView('list');
      if (listSection) listSection.setAttribute('hidden', '');
      if (emptyEl) emptyEl.removeAttribute('hidden');
      if (actions) actions.setAttribute('hidden', '');
      if (listMount) listMount.innerHTML = '';
      if (editMount) editMount.innerHTML = '';
      var panel = widget.querySelector('.mc-my-printers__panel');
      if (panel) panel.scrollTop = 0;
      syncBadgeFromStorage();
      return;
    }

    if (listMount) {
      listMount.innerHTML = devices.map(guestDeviceRowList).join('');
    }
    if (editMount) {
      editMount.innerHTML = devices.map(guestDeviceRowEdit).join('');
    }
    if (listSection) listSection.removeAttribute('hidden');
    if (emptyEl) emptyEl.setAttribute('hidden', '');
    if (actions) actions.removeAttribute('hidden');

    switchView('list');
    syncBadgeFromStorage();
  }

  function getServerDevicesFromJson() {
    var el = document.getElementById('mc-my-printers-server-json');
    if (!el) return [];
    try {
      var o = JSON.parse(el.textContent);
      return Array.isArray(o.devices) ? o.devices : [];
    } catch (e) {
      return [];
    }
  }

  function updateServerJsonCache(devices) {
    var el = document.getElementById('mc-my-printers-server-json');
    if (!el) return;
    try {
      el.textContent = JSON.stringify({ devices: devices });
    } catch (e) {}
  }

  /** Meta-Index aus localStorage + Liquid-Server-JSON (für GID→Name/Bild). */
  /**
   * Collection-Handle bevorzugen: Metaobject-Handle ist oft Prefix
   * (hp-deskjet-5740 vs hp-deskjet-5740-druckerpatronen).
   */
  function pickBetterHandle(a, b) {
    a = (a || '').trim();
    b = (b || '').trim();
    if (!a || a === 'lokal') return b || a;
    if (!b || b === 'lokal') return a;
    if (b.indexOf(a) === 0 && b.length > a.length) return b;
    if (a.indexOf(b) === 0 && a.length > b.length) return a;
    return b || a;
  }

  function buildDeviceMetaIndex() {
    var byGid = {};
    function ingest(list) {
      (list || []).forEach(function (d) {
        if (!d || !d.deviceGid) return;
        var prev = byGid[d.deviceGid] || {};
        var merged = Object.assign({}, prev, d);
        merged.handle = pickBetterHandle(prev.handle, d.handle);
        byGid[d.deviceGid] = merged;
      });
    }
    ingest(getServerDevicesFromJson());
    ingest(loadGuestDevices());
    return byGid;
  }

  /**
   * Server-Antwort (GID-Liste) ist autoritativ: Reihenfolge + Menge.
   * Display-Meta kommt aus dem lokalen Index.
   * Ohne Meta (Name/Handle) kein Eintrag — kein Platzhalter.
   */
  function applyAuthoritativeGids(gids) {
    if (!Array.isArray(gids)) gids = [];
    var meta = buildDeviceMetaIndex();
    var devices = [];
    var seen = new Set();
    gids.forEach(function (gid) {
      if (!gid || seen.has(gid)) return;
      seen.add(gid);
      if (!meta[gid]) return;
      devices.push(Object.assign({}, meta[gid], { deviceGid: gid }));
    });
    saveGuestDevices(devices);
    updateServerJsonCache(devices);
    renderWidgetFromStorage(devices);
    syncBadgeFromStorage();
    syncCollectionButtonsFromStorage();
    return devices;
  }

  function mergeServerDevicesIntoLocal(local, server) {
    var byGid = {};
    local.forEach(function (d) {
      if (d && d.deviceGid) byGid[d.deviceGid] = Object.assign({}, d);
    });
    server.forEach(function (s) {
      if (!s || !s.deviceGid) return;
      if (!byGid[s.deviceGid]) {
        byGid[s.deviceGid] = {
          deviceGid: s.deviceGid,
          handle: s.handle || 'lokal',
          name: s.name || s.handle || deviceFallbackName(),
          type: s.type || '',
          imageUrl: s.imageUrl || '',
        };
      } else {
        var existing = byGid[s.deviceGid];
        existing.handle = pickBetterHandle(existing.handle, s.handle);
        if (isPlaceholderName(existing.name) && s.name) existing.name = s.name;
        if (!existing.type && s.type) existing.type = s.type;
        if (!existing.imageUrl && s.imageUrl) existing.imageUrl = s.imageUrl;
      }
    });
    var order = [];
    var seen = new Set();
    server.forEach(function (s) {
      if (s && s.deviceGid && byGid[s.deviceGid] && !seen.has(s.deviceGid)) {
        order.push(byGid[s.deviceGid]);
        seen.add(s.deviceGid);
      }
    });
    local.forEach(function (d) {
      if (d && d.deviceGid && !seen.has(d.deviceGid)) {
        order.push(d);
        seen.add(d.deviceGid);
      }
    });
    return order;
  }

  // ---------------------------------------------------------------------------
  // API helpers (logged-in only)
  // ---------------------------------------------------------------------------

  function parseJsonSafe(text) {
    if (!text || !String(text).trim()) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  /**
   * App Proxy POST /apps/mcb/my-printers — Shopify hängt ?shop=…&logged_in_customer_id=… an.
   */
  async function apiCall(action, data) {
    var body = Object.assign({ action: action }, data);
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeoutId = null;
    if (controller) {
      timeoutId = window.setTimeout(function () {
        controller.abort();
      }, 15000);
    }
    var resp;
    try {
      resp = await fetch(APPPROXY_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined,
      });
    } catch (networkErr) {
      console.error('[MyPrinters] fetch failed:', networkErr);
      var ne = new Error(
        networkErr && networkErr.name === 'AbortError'
          ? lang('myPrintersErrorTimeout', 'Zeit\u00fcberschreitung (15s)')
          : lang('myPrintersErrorNetwork', 'Netzwerkfehler')
      );
      ne.cause = networkErr;
      throw ne;
    } finally {
      if (timeoutId != null) window.clearTimeout(timeoutId);
    }

    var text = await resp.text();
    var json = parseJsonSafe(text);

    if (!resp.ok) {
      var msg =
        json && (json.error || json.message)
          ? String(json.error || json.message)
          : text && text.trim().charAt(0) === '<'
            ? lang('myPrintersErrorProxyHtml', 'App Proxy lieferte HTML (HTTP __STATUS__)').replace('__STATUS__', resp.status)
            : text && text.length < 200
              ? text.trim()
              : 'HTTP ' + resp.status;
      var err = new Error(msg);
      err.status = resp.status;
      err.body = json || text;
      console.error('[MyPrinters] API error', resp.status, msg, APPPROXY_URL, text && text.slice(0, 300));
      throw err;
    }

    if (!json && text && text.trim().charAt(0) === '<') {
      var htmlErr = new Error(
        lang('myPrintersErrorProxyNotJson', 'App Proxy lieferte HTML statt JSON')
      );
      htmlErr.status = resp.status;
      throw htmlErr;
    }

    return json || {};
  }

  function addDeviceApi(deviceGid) {
    return apiCall('add', { deviceGid: deviceGid });
  }

  function removeDeviceApi(deviceGid) {
    return apiCall('remove', { deviceGid: deviceGid });
  }

  function reorderDevicesApi(deviceGids) {
    return apiCall('reorder', { deviceGids: deviceGids });
  }

  function mergeDevicesApi(deviceGids) {
    return apiCall('merge', { deviceGids: deviceGids });
  }

  function dropPendingMerges() {
    var ops = loadPendingOps().filter(function (o) {
      return o.action !== 'merge';
    });
    savePendingOps(ops);
  }

  async function flushPendingOps() {
    if (isGuest()) return;
    var ops = loadPendingOps();
    if (!ops.length) return;

    var remaining = [];
    for (var i = 0; i < ops.length; i++) {
      var op = ops[i];
      try {
        var res;
        if (op.action === 'add' && op.deviceGid) {
          res = await addDeviceApi(op.deviceGid);
        } else if (op.action === 'remove' && op.deviceGid) {
          res = await removeDeviceApi(op.deviceGid);
        } else if (op.action === 'reorder' && Array.isArray(op.deviceGids)) {
          var reorderGids = op.deviceGids.filter(Boolean);
          if (!reorderGids.length) continue;
          res = await reorderDevicesApi(reorderGids);
        } else if (op.action === 'merge' && Array.isArray(op.deviceGids)) {
          var mergeGids = op.deviceGids.filter(Boolean);
          if (!mergeGids.length) continue;
          res = await mergeDevicesApi(mergeGids);
        } else {
          // Drop corrupt/old-format ops (e.g. non-array deviceGids).
          continue;
        }
        if (res && Array.isArray(res.devices)) {
          applyAuthoritativeGids(res.devices);
        }
      } catch (e) {
        console.warn('[MyPrinters] pending op failed, keeping in queue', op, e);
        remaining.push(op);
      }
    }
    savePendingOps(remaining);
  }

  async function reconcileOnLogin() {
    if (!widget || isGuest()) return;

    var customerId = getCustomerId();
    var mergedFor = getMergedCustomerId();
    // Legacy flag was literal "1" — treat as unset so guest devices still merge once.
    if (mergedFor === '1') {
      clearMergedFlag();
      mergedFor = '';
    }

    var localGids = loadGuestDevices()
      .map(function (d) {
        return d.deviceGid;
      })
      .filter(Boolean);
    var server = getServerDevicesFromJson();
    var serverGids = server.map(function (s) { return s.deviceGid; }).filter(Boolean);
    var guestDirty = isGuestDirty();

    // Account switch → do not leak previous customer's local GIDs / pending merges.
    if (mergedFor && customerId && mergedFor !== customerId) {
      savePendingOps([]);
      clearGuestDirty();
      applyAuthoritativeGids(serverGids);
      setMergedForCustomer(customerId);
      // console.log('[MyPrinters] account switch → server metafield', serverGids.length);
      return;
    }

    // One-time guest→login merge only when guest actually added devices (dirty flag).
    // Do NOT merge stale localStorage on every reload — that undoes Admin/CS metafield edits.
    if (guestDirty && localGids.length > 0) {
      var preview = mergeServerDevicesIntoLocal(loadGuestDevices(), server);
      saveGuestDevices(preview);
      renderWidgetFromStorage(preview);
      syncBadgeFromStorage();
      syncCollectionButtonsFromStorage();
      try {
        var res = await mergeDevicesApi(localGids);
        applyAuthoritativeGids(res.devices || []);
        clearGuestDirty();
        dropPendingMerges();
        // console.log('[MyPrinters] guest→login merge OK', res);
      } catch (e) {
        console.warn('[MyPrinters] Login-Merge fehlgeschlagen', e);
        enqueuePending({ action: 'merge', deviceGids: localGids });
        applyAuthoritativeGids(serverGids);
      }
      setMergedForCustomer(customerId);
      await flushPendingOps();
      return;
    }

    // Normal logged-in load: Liquid metafield is the only source of truth (including empty).
    // Drop ALL pending ops — stale add/merge retries would re-write Admin/CS removals.
    clearGuestDirty();
    savePendingOps([]);
    applyAuthoritativeGids(serverGids);
    setMergedForCustomer(customerId);
    // console.log('[MyPrinters] server metafield → GUI', {
    //   serverCount: serverGids.length,
    //   serverGids: serverGids,
    //   liquidJson: server,
    // });
  }

  function initWidgetFromStorage() {
    if (!widget) return;

    if (isGuest()) {
      // After logout: always wipe Meine Drucker storage/GUI (was-logged-in flag survives account redirect).
      if (getMergedCustomerId() || getLastCustomerId() || wasLoggedIn()) {
        resetAfterLogout();
      } else {
        var local = loadGuestDevices();
        renderWidgetFromStorage(local);
        syncBadgeFromStorage();
        syncCollectionButtonsFromStorage();
      }
      return;
    }

    // Mark logged-in early so logout can clear even if reconcile is slow/fails.
    var cid = getCustomerId();
    if (cid) {
      try {
        localStorage.setItem(WAS_LOGGED_IN_KEY, '1');
        sessionStorage.setItem(LAST_CUSTOMER_KEY, cid);
      } catch (e) {}
    }

    reconcileOnLogin();
  }

  // ---------------------------------------------------------------------------
  // Widget toggle
  // ---------------------------------------------------------------------------

  function openWidget() {
    if (!widget) return;
    widget.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = widget.querySelector('.mc-my-printers__panel');
    if (panel) panel.scrollTop = 0;
    // Do not flush pending on open — that could re-apply stale adds after Admin edits.
    // Pending is flushed after explicit write failures / guest→login merge only.
  }

  function closeWidget() {
    if (!widget) return;
    widget.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // Discard unsaved edit-view drag order / refresh empty vs list.
    // Do not call switchView() afterwards — that clears [hidden] on the list
    // section and breaks the empty state (list flex:1 pushes empty UI to the bottom).
    renderWidgetFromStorage(loadGuestDevices());
  }

  function toggleWidget() {
    if (!widget) return;
    var isHidden = widget.getAttribute('aria-hidden') === 'true';
    if (isHidden) openWidget();
    else closeWidget();
  }

  // ---------------------------------------------------------------------------
  // View switching (list <-> edit)
  // ---------------------------------------------------------------------------

  function switchView(viewName) {
    if (!widget) return;
    var views = widget.querySelectorAll('[data-my-printers-view]');
    views.forEach(function (view) {
      if (view.dataset.myPrintersView === viewName) {
        view.hidden = false;
      } else {
        view.hidden = true;
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Drag-and-drop reorder
  // ---------------------------------------------------------------------------

  var draggedItem = null;

  function initDragAndDrop() {
    var sortable = widget && widget.querySelector('[data-my-printers-sortable]');
    if (!sortable || sortable.dataset.mcDndInit === '1') return;
    sortable.dataset.mcDndInit = '1';

    sortable.addEventListener('dragstart', function (e) {
      var et = eventTargetElement(e);
      var item = et && et.closest ? et.closest('.mc-my-printers__edit-item') : null;
      if (!item) return;
      draggedItem = item;
      item.classList.add('is-dragging');
      e.dataTransfer.effectAllowed = 'move';
    });

    sortable.addEventListener('dragend', function () {
      if (draggedItem) draggedItem.classList.remove('is-dragging');
      draggedItem = null;
      sortable.querySelectorAll('.drag-over').forEach(function (el) {
        el.classList.remove('drag-over');
      });
    });

    sortable.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      var et = eventTargetElement(e);
      var target = et && et.closest ? et.closest('.mc-my-printers__edit-item') : null;
      if (!target || target === draggedItem) return;
      sortable.querySelectorAll('.drag-over').forEach(function (el) {
        el.classList.remove('drag-over');
      });
      target.classList.add('drag-over');
    });

    sortable.addEventListener('drop', function (e) {
      e.preventDefault();
      var et = eventTargetElement(e);
      var target = et && et.closest ? et.closest('.mc-my-printers__edit-item') : null;
      if (!target || !draggedItem || target === draggedItem) return;
      target.classList.remove('drag-over');
      sortable.insertBefore(draggedItem, target);
    });
  }

  // ---------------------------------------------------------------------------
  // Remove / save / add
  // ---------------------------------------------------------------------------

  function handleRemove(deviceGid) {
    if (!deviceGid) return;

    var devices = loadGuestDevices().filter(function (d) {
      return d.deviceGid !== deviceGid;
    });
    saveGuestDevices(devices);
    renderWidgetFromStorage(devices);
    syncBadgeFromStorage();
    syncCollectionButtonsFromStorage();

    if (isGuest()) return;

    removeDeviceApi(deviceGid)
      .then(function (res) {
        applyAuthoritativeGids(res.devices || []);
      })
      .catch(function (e) {
        console.warn('[MyPrinters] remove fehlgeschlagen — in Retry-Queue', e);
        enqueuePending({ action: 'remove', deviceGid: deviceGid });
      });
  }

  function handleSave() {
    var sortable = widget.querySelector('[data-my-printers-sortable]');
    if (!sortable) return;
    var order = [];
    sortable.querySelectorAll('.mc-my-printers__edit-item').forEach(function (item) {
      order.push(item.dataset.deviceGid);
    });
    var devices = loadGuestDevices();
    var map = {};
    devices.forEach(function (d) {
      map[d.deviceGid] = d;
    });
    var reordered = order
      .map(function (gid) {
        return map[gid];
      })
      .filter(Boolean);
    saveGuestDevices(reordered);
    renderWidgetFromStorage(reordered);
    switchView('list');
    syncBadgeFromStorage();
    syncCollectionButtonsFromStorage();

    if (isGuest()) return;

    reorderDevicesApi(order.filter(Boolean))
      .then(function (res) {
        applyAuthoritativeGids(res.devices || order);
      })
      .catch(function (e) {
        console.warn('[MyPrinters] reorder fehlgeschlagen — in Retry-Queue', e);
        enqueuePending({ action: 'reorder', deviceGids: order.filter(Boolean) });
      });
  }

  function collectionHandleFromPath() {
    try {
      var m = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function resolveCollectionHandle(btn) {
    var wrap = btn.closest('.mc-add-to-printers');
    var h = (wrap && wrap.getAttribute('data-collection-handle') || '').trim();
    if (h) return h;
    h = collectionHandleFromPath();
    if (h) return h;
    return 'lokal';
  }

  function readDeviceFromButton(btn) {
    var wrap = btn.closest('.mc-add-to-printers');
    if (!wrap) return null;
    var dg =
      wrap.getAttribute('data-device-gid') ||
      (btn.getAttribute && btn.getAttribute('data-device-gid')) ||
      (btn.dataset && btn.dataset.deviceGid) ||
      '';
    return {
      deviceGid: dg,
      handle: resolveCollectionHandle(btn),
      name: (wrap.getAttribute('data-device-name') || '').trim(),
      type: (wrap.getAttribute('data-device-type') || '').trim(),
      imageUrl: (wrap.getAttribute('data-device-image-url') || '').trim(),
    };
  }

  function resolveDeviceGid(btn) {
    var wrap = btn.closest('.mc-add-to-printers');
    return (
      (btn.getAttribute && btn.getAttribute('data-device-gid')) ||
      (wrap && wrap.getAttribute('data-device-gid')) ||
      btn.dataset.deviceGid ||
      ''
    ).trim();
  }

  function handleAddFromCollection(btn) {
    var deviceGid = resolveDeviceGid(btn);
    if (!deviceGid) {
      console.warn('[MyPrinters] Missing data-device-gid on add button');
      alert(lang('myPrintersErrorMissingDeviceData', 'Ger\u00e4tedaten fehlen. Bitte Seite neu laden.'));
      return;
    }

    var info = readDeviceFromButton(btn);
    if (!info || !info.deviceGid) {
      alert(lang('myPrintersErrorMissingDeviceData', 'Ger\u00e4tedaten fehlen. Bitte Seite neu laden.'));
      return;
    }

    var devices = loadGuestDevices();
    var alreadyLocal = devices.some(function (d) {
      return d.deviceGid === deviceGid;
    });

    if (!alreadyLocal) {
      devices.push({
        deviceGid: deviceGid,
        handle: info.handle,
        name: info.name || info.handle,
        type: info.type || '',
        imageUrl: info.imageUrl || '',
      });
      saveGuestDevices(devices);
    }

    btn.classList.add('mc-add-to-printers__btn--saved');
    btn.setAttribute('data-action', 'open-my-printers-edit');
    btn.innerHTML =
      '<span class="mc-add-to-printers__icon" aria-hidden="true">&#x2713;</span>' +
      '<span class="mc-add-to-printers__text">' + escapeHtml(lang('myPrintersButtonSaved', 'Zu meinen Druckern hinzugef\u00fcgt')) + '</span>';
    syncBadgeFromStorage();
    renderWidgetFromStorage(loadGuestDevices());
    openWidget();
    switchView('list');
    syncCollectionButtonsFromStorage();

    // Guests only use localStorage — no App Proxy call.
    if (isGuest()) {
      setGuestDirty();
      console.warn(
        '[MyPrinters] Gast-Modus: nur localStorage — Metafeld wird nicht geschrieben. Bitte einloggen.'
      );
      return;
    }

    // Always sync to server when logged in (even if already in localStorage from a
    // prior guest add) — otherwise the metafield never gets updated.
    // console.log('[MyPrinters] add → API', deviceGid);
    addDeviceApi(deviceGid)
      .then(function (res) {
        // console.log('[MyPrinters] add ← API OK', res);
        applyAuthoritativeGids(res.devices || []);
      })
      .catch(function (e) {
        console.warn('[MyPrinters] add fehlgeschlagen — in Retry-Queue', e);
        enqueuePending({ action: 'add', deviceGid: deviceGid });
        alert(
          lang('myPrintersErrorSaveFailed', 'Drucker konnte nicht gespeichert werden:') +
            '\n' +
            (e && e.message ? e.message : String(e)) +
            '\n\n' +
            lang('myPrintersErrorSaveFailedDetails', '(Details in der Browser-Konsole unter [MyPrinters])')
        );
      });
  }

  // ---------------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------------

  document.addEventListener('click', function (e) {
    var t = eventTargetElement(e);
    if (!t || typeof t.closest !== 'function') return;
    var actionEl = t.closest('[data-action]');
    if (!actionEl) return;

    var action = actionEl.getAttribute('data-action');
    if (!action) return;

    switch (action) {
      case 'toggle-my-printers':
        e.preventDefault();
        toggleWidget();
        break;

      case 'close-my-printers':
        closeWidget();
        break;

      case 'my-printers-edit':
        e.preventDefault();
        switchView('edit');
        break;

      case 'my-printers-done':
        e.preventDefault();
        handleSave();
        break;

      case 'my-printers-cancel':
        e.preventDefault();
        window.location.reload();
        break;

      case 'my-printers-save':
        e.preventDefault();
        handleSave();
        break;

      case 'my-printers-remove':
        e.preventDefault();
        handleRemove(actionEl.dataset.deviceGid);
        break;

      case 'add-to-my-printers':
        e.preventDefault();
        handleAddFromCollection(actionEl);
        break;

      case 'open-my-printers-edit':
        e.preventDefault();
        openWidget();
        switchView('edit');
        break;

      case 'mc-focus-search':
        e.preventDefault();
        focusMcSearch();
        break;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeWidget();
  });

  // Clear Meine Drucker immediately when the user clicks logout (before redirect).
  document.addEventListener('click', function (e) {
    var t = eventTargetElement(e);
    if (!t || typeof t.closest !== 'function') return;
    var a = t.closest('a[href*="/account/logout"], a[href*="/customer_authentication/logout"]');
    if (!a) return;
    resetAfterLogout();
  });

  window.addEventListener('online', function () {
    if (!isGuest()) flushPendingOps();
  });

  initDragAndDrop();
  initWidgetFromStorage();
})();
